<template>
  <v-app>
    <v-container fill-height>
      <v-card elevation="20" class="mx-auto" width="400">
        <p style="font-size: 16px" class="pt-5 font-weight-black text-center">เข้าสู่ระบบศิษย์เก่า</p>
        <v-card-text>
          <v-form @submit.prevent="submit" ref="form" lazy-validation>
            <v-row>
              <v-col lg="12" md="12" sm="12" cols="12">
                <v-text-field
                  :rules="TextRule"
                  maxlength="17"
                  prepend-icon="mdi-account-tie"
                  v-model="usernameIdentityValue"
                  label="รหัสบัตรประชาชน"
                  clearable
                  required
                ></v-text-field>
                <!-- <v-text-field
                  :rules="TextRule"
                  maxlength="17"
                  v-mask="{
                    mask: '#-####-#####-##-#',
                    unmaskedVar: 'usernameIdentityValue',
                  }"
                  prepend-icon="mdi-account-tie"
                  v-model="usernameIdentity"
                  label="รหัสบัตรประชาชน"
                  clearable
                  required
                ></v-text-field> -->
              </v-col>
              <v-col lg="12" md="12" sm="12" cols="12">
                <v-row>
                  <v-col lg="4" md="4" sm="12" cols="12">
                    <v-select
                      v-model="day"
                      :items="dayData"
                      :rules="[(v) => !!v || 'กรุณาเลือกวันเกิด']"
                      menu-props="auto"
                      label="วัน"
                      hide-details
                      prepend-icon="mdi-lock"
                      item-value="day_id"
                      item-text="day_id"
                      single-line
                      required
                    ></v-select>
                  </v-col>
                  <v-col lg="4" md="4" sm="12" cols="12">
                    <v-select
                      v-model="month"
                      :items="monthData"
                      :rules="[(v) => !!v || 'กรุณาเลือกเดือนเกิดของท่าน']"
                      menu-props="auto"
                      label="เดือน"
                      item-value="month_id"
                      item-text="month_name"
                      single-line
                      required
                    ></v-select>
                  </v-col>
                  <v-col lg="4" md="4" sm="12" cols="12">
                    <v-select
                      v-model="year"
                      :items="yearData"
                      :rules="[(v) => !!v || 'กรุณาเลือกปีเกิดของท่าน']"
                      menu-props="auto"
                      label="ปีเกิด"
                      item-value="year_id"
                      item-text="year_id"
                      single-line
                      required
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div class="text-center">
              <Turnstile ref="turnstileRef" :site-key="key" @success="onTurnstileSuccess" />
            </div>
            <v-row class="mt-5 mb-1 mx-1">
              <v-btn block type="submit" class="mr-4" color="dark" :disabled="!isToken"> เข้าสู่ระบบ </v-btn>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { mask } from "@titou10/v-mask";
import Turnstile from "@/components/Turnstile.vue";
export default {
  name: "Login",
  directives: { mask },
  components: {
    Turnstile,
  },
  data() {
    return {
      tabs: null,
      usernameIdentity: "",
      usernameIdentityValue: "",
      day: "",
      month: "",
      year: "",
      dayData: [],
      monthData: [
        {
          month_id: "01",
          month_name: "มกราคม",
        },
        {
          month_id: "02",
          month_name: "กุมภาพันธ์",
        },
        {
          month_id: "03",
          month_name: "มีนาคม  ",
        },
        {
          month_id: "04",
          month_name: "เมษายน",
        },
        {
          month_id: "05",
          month_name: "พฤษภาคม ",
        },
        {
          month_id: "06",
          month_name: "มิถุนายน",
        },
        {
          month_id: "07",
          month_name: "กรกฎาคม",
        },
        {
          month_id: "08",
          month_name: "สิงหาคม",
        },
        {
          month_id: "09",
          month_name: "กันยายน",
        },
        {
          month_id: "10",
          month_name: "ตุลาคม",
        },
        {
          month_id: "11",
          month_name: "พฤศจิกายน",
        },
        {
          month_id: "12",
          month_name: "ธันวาคม",
        },
      ],
      yearData: [],
      TextRule: [(v) => !!v || "กรุณากรอกข้อมูล"],
      token: null,
      key: process.env.VUE_APP_TURNSTILE_KEY || null,
    };
  },
  async mounted() {
    await this.getDate();
    localStorage.clear();
  },
  computed: {
    isToken() {
      return this.token !== null && this.token !== undefined && this.token !== "";
    },
  },
  methods: {
    onTurnstileSuccess(token) {
      this.token = token;
    },
    convert(n) {
      n = String(n);
      if (n.length == 1) n = "0" + n;
      return n;
    },
    getDate() {
      for (let d = 1; d <= 31; d++) {
        var obj = {};
        obj["day_id"] = this.convert(d);
        this.dayData.push(obj);
      }

      var start_year = new Date().getFullYear() + 543;
      for (var i = start_year; i > start_year - 50; i--) {
        var objYear = {};
        objYear["year_id"] = i;
        this.yearData.push(objYear);
      }
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch({
          type: "doLogin",
          identity: this.usernameIdentityValue,
          pwd: `${this.day}${this.month}${this.year}`,
          turnstile: this.token,
        });
      }
    },
  },
};
</script>

<style></style>
